import { AccordionItem } from '@carbon/react';
import { useId } from 'react';
import { CdCheckbox } from '../../atoms/CdCheckbox';
import { CdIndicatorDot } from '../../atoms/CdIndicatorDot';
import { CdTag } from '../../atoms/CdTag';
import styles from './CdFilterGroup.module.scss';

export interface FilterOption {
  id: string;
  label: string;
  checked: boolean;
}

export interface CdFilterGroupProps {
  id: string;
  title: string;
  options: FilterOption[];
  onOptionChange: (optionId: string, checked: boolean) => void;
  open?: boolean;
}

/**
 * One accordion section of a filter / column panel. Shows a dot when any option is selected.
 * Must be rendered inside a Carbon `Accordion` (FilterPanel / ManageColumnsPanel do this).
 */
export const CdFilterGroup = ({ id, title, options, onOptionChange, open }: CdFilterGroupProps) => {
  const instanceId = useId();
  const changed = options.some((o) => o.checked);
  return (
    <AccordionItem
      open={open}
      title={
        <span className={styles.title}>
          {title}
          {changed && <CdIndicatorDot label="Has selections" />}
        </span>
      }
    >
      <ul className={styles.options}>
        {options.map((option) => (
          <li key={option.id} className={styles.option}>
            <CdCheckbox
              id={`${instanceId}-${id}-${option.id}`}
              labelText={<CdTag label={option.label} variant="selectable" />}
              checked={option.checked}
              onCheckedChange={(checked) => onOptionChange(option.id, checked)}
            />
          </li>
        ))}
      </ul>
    </AccordionItem>
  );
};
